var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPauseCircleFilled = function SvgPauseCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.015 7.99a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM5 10.5a1 1 0 1 0 2 0v-5a1 1 0 0 0-2 0v5Zm4 0a1 1 0 1 0 2 0v-5a1 1 0 0 0-2 0v5Z",
    clipRule: "evenodd"
  })));
};
export default SvgPauseCircleFilled;